import { graphql } from "msw";

import { FooterDataQuery } from "@header/generated/graphql";

import { MOCK_FOOTER_DATA } from "../data";

export const footerHandlers = [
  graphql.query<FooterDataQuery>("FooterData", (_request, response, ctx) => {
    return response(
      ctx.data({
        footer: MOCK_FOOTER_DATA,
      })
    );
  }),
];
